module.exports = __webpack_public_path__ + "img/delivery.f99e94f2.png";